import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import DashboardInsights from "../components/dashboardInsights";
import Hero from "../components/hero";
import Newsletter from "../components/newsLetter";
import Services from "../components/services";
import Partners from "../components/partners";

const Home = () => {

  useEffect(() => {
    const targetId = localStorage.getItem("scrollTarget");
    if (targetId) {
      const el = document.getElementById(targetId);
      if (el) {
        // Add a small delay so the DOM is ready
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 1000);
      }
      localStorage.removeItem("scrollTarget");
    }
  }, []);

  return (
    <>
      <Hero/>
      <Services/>
      <DashboardInsights/>
      <Partners/>
      <Newsletter/>
    </>
  );
};

export default Home;
